module.exports = __webpack_public_path__ + "img/tan-lih-tyng-2.c49dd343.png";